module.exports = __webpack_public_path__ + "img/wagoneer_logo.e2920b60.png";